<template>
	<div class="main">
		<header class="page-title">
			<h2>Provider Lists</h2>
			<div class="ml-auto" v-if="userRoles.includes('provider_lists_tables.create')">
				<a :href="'/' + selectedSite.slug + '/provider-lists/create'" class="btn btn-md btn-success"><i class="fas fa-plus"></i> New Provider List</a>
			</div>
		</header>

		<div class="flex center text-center mb-1" v-if="loader">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>

		<form :action="endPoint" class="list-filter flex box" method="get" ref="filterForm" v-if="!loader">
			<div class="two form-group">
				<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
				<select @change="onFormChange" id="limit" name="limit" v-model="selectedLimit">
					<option value="null">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>

			<div class="two form-group">
				<label for="provider-type-dropdown"><i class="fas fa-fw fa-archive"></i> Provider Type</label>
				<select @change="onFormChange" id="provider-type-dropdown" name="provider_type" v-model="selectedProviderType">
					<option value="null">All</option>
					<option :value="type.id" v-for="type in types">{{ type.name }}</option>
				</select>
			</div>
			<div class="eight form-group">
				<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
				<div class="input-group">
					<input @change="checkReset" @keyup="onFilterChange" class="input-small" id="filter" name="filter" placeholder="Filter in ..." type="text" v-model="urlParams.filter">
					<button @click="clearForm" class="btn btn-primary">Filter</button>
				</div>
			</div>
		</form>
		<div class="table-reponsive">
			<table>
				<thead>
					<tr>
						<th>List Name</th>
						<th>Description</th>
						<th>Provider Type</th>
						<th>Articles</th>
						<th>Shared</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="providerList in providerListList">
						<td>{{ providerList.name }}</td>
						<td>{{ providerList.description }}</td>
						<td>{{ providerList.type }}</td>
						<td>{{ providerList.articleCounter }}</td>
						<td>{{ providerList.sharedCounter }}</td>
						<td class="nowrap">
							<a :disabled="!userRoles.includes('provider_lists_tables.view')" :href="'/' + selectedSite.slug + '/provider-lists/' + providerList.id + '/edit'" class="btn btn-icon btn-primary" title="Edit"><i class="fas fa-pencil-alt"></i></a>
							<a :disabled="!userRoles.includes('provider_lists_tables.delete')" @click.prevent="deleteProviderList(providerList.id)" class="btn btn-icon btn-danger" title="Trash"><i class="fas fa-trash-alt"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>

	export default {
		props: {
			dataProviderLists: {
				type: Array
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
			dataStatuses: {
				type: Array
			},
			dataEndpoint: {
				type: String
			},
			dataTypes: {
				type: Array
			},
			dataSelectedTypeId: {
				type: Number,
				required: false
			},
		},
		data() {
			return {
				userRoles: this.$currentUserRoles,
				providerListList: this.dataProviderLists,
				statuses: this.dataStatuses || [],
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || {},
				selectedSite: this.$selectedSite,
				loader: false,
				filterEnabled: this.dataUrlParams.filter && this.dataUrlParams.filter.length > 0,
				selectedLimit: this.dataUrlParams.limit ? this.dataUrlParams.limit : null,
				types: this.dataTypes,
				selectedProviderType: this.dataUrlParams.provider_type ? this.dataUrlParams.provider_type : null,
			}
		},
		methods: {
			clearForm: function () {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === 'null' || $(inp).val() === null)
						inp.disabled = true;
				});
			},
			checkReset: function () {
				if (this.urlParams.filter.length === 0) {
					this.onFormChange();
				}
			},
			onFormChange: function () {
				this.loader = true;
				this.clearForm();
				this.$refs.filterForm.submit();
			},
			onFilterChange: function () {
				this.filterEnabled = this.urlParams.filter && this.urlParams.filter.length > 0;
			},
			deleteProviderList: function (id) {
				let vm = this;
				vm.$dialog.confirm('Are you sure you want to delete this Provider List?')
						.then((dialog) => {
							axios.delete('/api/' + vm.$selectedSite.slug + '/provider-list/' + id)
									.then(response => {
										vm.$toastr.success('Delete successful.');
										location.reload();
									})
									.catch(errors => {
										dialog.close();
										vm.$toastr.error('Delete failed.');
									});
						})
						.catch(error => {
							vm.$toastr.error('Delete aborted.');
						});
			}
		}
	}
</script>

<style scoped>

</style>
